(function () {
  var productPageElement = document.querySelector('wdn-product-page');
  var t = document.querySelectorAll('[name*="option-variant"]');

  var handleRadioChange = function () {
    if (document.querySelector('[data-variant-group-insane]')) {
      document.body.dispatchEvent(new CustomEvent('variant:change:insane'));
    }

    t.forEach(function (elem) {
      if (this.checked && elem.value == this.value) {
        elem.checked = true;
      } else {
        elem.checked = false;
      }
    }, this);

    var activeDyeInputs = document.querySelectorAll('.variant-option-input:checked');
    var formSubmitPreventer = document.querySelector('[data-form-submit-preventer]');

    // Bulk with variants
    if (document.querySelector('[data-bulk-with-variant]')) {
      var variantId = this.value;

      if (productPageElement) {
        productPageElement.dispatchEvent(
          new CustomEvent('variant:change:bulk', {
            detail: { variantId: variantId },
          })
        );
      }

      // Else - Handle bulk with no variants
    } else {
      var formVariantId = document.querySelector('[data-product-line-id]');
      formVariantId.value = variantId;
    }

    if (activeDyeInputs.length > 0) {
      var qe = document.querySelector('.variant__group');
      qe.removeAttribute('data-has-error');
      formSubmitPreventer.checked = true;
      return;
    }

    formSubmitPreventer.checked = false;
  };

  t.forEach(function (elem) {
    elem.addEventListener('click', handleRadioChange);
  });

  var onMainFormSubmit = function (e) {
    var activeDyeInputs = document.querySelectorAll('.variant-option-input:checked');

    if (activeDyeInputs.length == 0) {
      var qe = document.querySelector('.variant__group');
      qe.setAttribute('data-has-error', '');
    }
  };

  var pt = document.querySelector('.productpage__submit-btn');
  pt.addEventListener('click', onMainFormSubmit);
})();
